import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/video/Sminex_SimplePrive.mp4")